import sweetheart_down from "../../../assets/images/sweetheart_down.svg";
import arrow_up from "../../../assets/images/arrow_up.svg";
import { useState } from "react";

export default function VacancieItem({ title, description, requirements }) {
    const [open, setOpen] = useState(false);
    return (
        <div className='flex flex-col justify-center items-center w-[300px] md:w-[340px] lg:w-[460px] xl:w-[370px]'>
            <img src={sweetheart_down} alt="sweetheart_down" />
            <span className="text-[18px] lg:text-[20px] leading-[30px] text-[#8C4E8C] text-center font-semibold mt-[10px]">{title}</span>
            <p className="text-[14px] lg:text-[15px] leading-[25px] mt-[23px] font-normal">{description}</p>
            <div className="flex flex-col w-full text-[14px] md:text-[15px]">
                <h3 className="text-left w-full font-semibold my-[14px] leading-[25px] hidden sm:flex">Requirements:</h3>
                <ul className={`hidden list-none pl-5 sm:flex flex-col gap-[10px]`}>
                    {requirements.map((requirement, index) => (
                        <li
                            key={index}
                            className="relative pl-5 before:content-['•'] before:absolute before:left-0 before:top-[-1px] before:text-black font-normal"
                        >
                            {requirement}
                        </li>
                    ))}
                </ul>
                <div className="flex items-center sm:hidden border-[2px] border-[#71AD80] rounded-[5px] w-full h-[40px] px-[10px] cursor-pointer mt-[8px]"
                    onClick={() => setOpen(!open)}
                >
                    <span className="text-left text-[14px] w-full font-semibold leading-[25px]">Requirements</span>
                    <img src={arrow_up} alt="arrow" className={`${open ? "rotate-0" : "rotate-180"} transition-transform duration-500 ease-in-out`} />
                </div>
                <ul className={`list-none pl-2 pt-4 flex flex-col sm:hidden gap-[10px] ${open ? "max-h-[1000px] opacity-100 pointer-events-all" : "max-h-0 opacity-0 pointer-events-none"} transition-all duration-600 ease-in-out`}>
                    {requirements.map((requirement, index) => (
                        <li
                            key={index}
                            className="relative pl-5 before:content-['•'] before:absolute before:left-0 before:top-[-1px] before:text-black font-normal"
                        >
                            {requirement}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}